import { memo, FC } from "react";
import Placeholder from "images/lost-network.png";
import BackButton from 'components/BackButton';
import styles from "./index.module.scss";

interface INotFound {}

const NotFound: FC<INotFound> = () => {
  return (
    <div className={styles.root}>
      <img src={Placeholder} alt="NotFoundImg" />
      <BackButton />
    </div>
  );
};

export default memo(NotFound);
